import AddressCheckAddressModel from './addressCheckAddressModel';
import { format } from '../../../home24-shared/core/Utils';

export default function AddressCheckAddressParser(data, ownAddress) {
    var models = [];
    var me = this;

    if (!data || data.status === 'ZERO_RESULTS' || data.status === 'UNKNOWN_ERROR' || data.results.length === 0) {
        return models;
    }
    data.results.forEach(function (record) {
        models.push(me.decoupler(record, ownAddress));
    });

    return models;
}

AddressCheckAddressParser.prototype = {
    _googleAddressHierarchy: {
        place_id: 'index',
        formatted_address: 'full',
        partial_match: 'suggestedAddress',
        address_components: {
            route: 'street',
            street_number: 'streetNumber',
            postal_code: 'zip',
            locality: 'city',
            country: 'country'
        }
    },

    decoupler: function (record, ownAddress) {
        var matrix = this._googleAddressHierarchy;
        var key;
        var type;
        var streetNumberFirst;
        var address = new AddressCheckAddressModel();

        for (key in matrix) { // eslint-disable-line no-restricted-syntax
            if (!matrix.hasOwnProperty(key)) {
                continue;
            }

            if (typeof(matrix[key]) === 'string') {
                address.set(matrix[key], record[key]);
            } else if (typeof(matrix[key]) === 'object') {
                var types = matrix[key];
                var components = this._componentsGrabber(record[key]);

                for (type in types) { // eslint-disable-line no-restricted-syntax
                    if (!types.hasOwnProperty(type)) {
                        continue;
                    }
                    address.set(types[type], components[type]);
                }
            }
        }

        streetNumberFirst = (address.get('full').indexOf(address.get('streetNumber')) === 0);

        address.set('street', format('{0} {1}', (streetNumberFirst) ? address.get('streetNumber') : address.get('street'), (streetNumberFirst) ? address.get('street') : address.get('streetNumber')));
        address.set('full', address.toString());
        if (ownAddress) {
            address.set('ownAddress', (address.get('full') === ownAddress.get('full')));
        } else {
            address.set('ownAddress', (!address.get('suggestedAddress')));
        }

        return address;
    },

    _componentsGrabber: function (componenstArr) {
        var components = {};
        var c;

        componenstArr.forEach(function (component) {
            for (c in component.types) { // eslint-disable-line no-restricted-syntax
                if (!component.types.hasOwnProperty(c)) {
                    continue;
                }
                components[component.types[c]] = component.long_name;
            }
        });

        return components;
    }
};




/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckAddressParser.js
 **/